/* eslint-disable @typescript-eslint/unbound-method */
import { forwardRef, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { UserCreateService } from '@se-po/shared-data-access-services'
import { BehaviorSubject } from 'rxjs'
import { first } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => PasswordFormSubmitService),
  deps: [Router, UserCreateService, StoreService]
})
export abstract class PasswordFormSubmitter {
  public abstract submitting: BehaviorSubject<boolean>
  public abstract unknownError: boolean
  public abstract submit(store: StoreService): void
  public abstract redirect (url: string): void
  public abstract validateAccount(store: StoreService): void
  public abstract validateAndSubmit(store: StoreService, captchaRef?: any): void
}

@Injectable({
  providedIn: 'root'
})
export class PasswordFormSubmitService implements PasswordFormSubmitter {
  public submitting = new BehaviorSubject<boolean>(false)
  public unknownError = false

  constructor(
    private router: Router,
    private userCreateService: UserCreateService,
  ) { }

  public validateAndSubmit(store: StoreService, captchaRef?: any): void {
    if (store.captchaResponse) this.submit(store)
    else if (captchaRef) captchaRef.execute()
    else console.error('Invalid Captcha')
  }

  public submit(store: StoreService): void {
    const params = store.createAccountParams
    this.userCreateService.create(params)
      .pipe(first())
      .subscribe(
        (result) => {
          this.unknownError = false
          const redirectTo = result?.redirect_to
          if (redirectTo) return this.redirect(redirectTo)

          store.createdAccount.next(result)
          this.submitting.next(false)
          void this.router.navigate([store.basePath, 'verification'])
        },
        (err) => {
          console.error('Unknown Error', { err, messages: err?.messages })
          this.submitting.next(false)
          this.unknownError = true
        }
      )
  }

  public redirect(url: string): void {
    window.location.href = url
  }

  public validateAccount(store: StoreService): void {
    // ensure the user has come through the account info and dupe checks
    if (!store.accountValid) {
      void this.router.navigate([store.basePath])
    }
  }
}
